import { useState } from 'react';

import ServerError from './server-error';

type RTKQueryError = {
  status: number;
  data: ServerError;
};

function getBoundedError(error: unknown): Error {
  if (error instanceof ServerError) {
    if (error.statusCode === 400) {
      return new Error(`Bad request. ${error.message}`);
    }
    return new Error(`Server error ${error.statusCode}: ${error.message}`);
  }
  if (error instanceof Error) {
    return error;
  }
  if (typeof error === 'string') {
    return new Error(error);
  }
  const { data: serverError } = (error as RTKQueryError);
  return new Error(`Server error ${serverError.statusCode}: ${serverError.message}`);
}

export default function useErrorHandler(givenError?: unknown): (error: unknown) => void {
  const [error, setError] = useState<unknown>(null);

  if (givenError) {
    throw getBoundedError(givenError);
  }
  if (error !== null && error instanceof Error) throw error;
  return (err: unknown) => {
    setError(getBoundedError(err));
  };
}
